import Player from '@vimeo/player';

function detectVideoPlatform(urlString) {
    try {
        // Add protocol if missing so the URL parser doesn't throw an error
        const formattedUrl = urlString.match(/^https?:\/\//i) ? urlString : `https://${urlString}`;
        const hostname = new URL(formattedUrl).hostname.toLowerCase().replace(/^www\./, '');

        if (['youtube.com', 'youtu.be', 'm.youtube.com', 'youtube-nocookie.com'].includes(hostname)) {
        return 'YouTube';
        }

        if (['vimeo.com', 'player.vimeo.com'].includes(hostname)) {
        return 'Vimeo';
        }

        return 'Unknown';
    } catch (e) {
        return 'Invalid URL';
    }
}

function getYouTubeId(url) {
    const regExp = /(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=|shorts\/))([\w-]{11})/;
    const match = url.match(regExp);
    
    return (match && match[1]) ? match[1] : null;
  }




export default function VideoHandler() {
    const videoContainers = document.querySelectorAll('[data-video-url]');

    if (videoContainers) {
        [].forEach.call(videoContainers, videoContainer => {
            videoContainer.innerHTML = '';

            const playBtn = videoContainer.parentNode.querySelector('[data-video-play]');
            const muteBtn = videoContainer.parentNode.querySelector('[data-video-mute]');
            const fullBtn = videoContainer.parentNode.querySelector('[data-video-fullscreen]');

            switch(detectVideoPlatform(videoContainer.dataset.videoUrl)){
                case 'YouTube':
                    const ytVideoID = getYouTubeId(videoContainer.dataset.videoUrl);

                    window.onYouTubeIframeAPIReady = function() {
                        console.log('YouTube Iframe API is ready!');
                        
                        // Initialize your player here
                        const ytPlayer = new YT.Player(videoContainer, {
                            videoId: ytVideoID,
                            playerVars: {
                                controls: 0,       // 0 = Hides all player controls (play/pause, volume, timeline, settings)
                                disablekb: 1,      // 1 = Disables keyboard controls (spacebar pause, arrow keys skip)
                                modestbranding: 1, // 1 = Hides YouTube logo in control bar
                                rel: 0,            // 0 = Shows related videos only from the same channel when paused/ended
                                playsinline: 1,
                                mute: 1,
                            }
                        });

                        if (playBtn) {
                            playBtn.addEventListener('click', () => {
                                const state = ytPlayer.getPlayerState();
                                // 1 = Playing
                                if (state === YT.PlayerState.PLAYING) {
                                    ytPlayer.pauseVideo();
                                } else {
                                    ytPlayer.playVideo();
                                }

                                playBtn.classList.toggle('state2');
                            });
                        }
    
                        if (muteBtn) {
                            muteBtn.addEventListener('click', () => {
                                if (ytPlayer.isMuted()) {
                                    ytPlayer.unMute();
                                } else {
                                    ytPlayer.mute();
                                }
                                muteBtn.classList.toggle('state2');
                            });
                        }
    
                        if (fullBtn) {
                            fullBtn.addEventListener('click', () => {
                                ytPlayer.getIframe().parentNode.requestFullscreen();
                            });
                        }
                    };
                break;
                case 'Vimeo':
                    const player = new Player(videoContainer, {
                        url: videoContainer.dataset.videoUrl,
                        responsive: true,
                        dnt: true,
                        controls: false,
                        autopause: true,
                        referrerpolicy: 'strict-origin-when-cross-origin',
                    });
                    player.setVolume(0);

                    if (playBtn) {
                        playBtn.addEventListener('click', () => {
                            player.getPaused().then(paused => {
                                if (paused) {
                                    player.play();
                                } else {
                                    player.pause();
                                }
                            });
                            playBtn.classList.toggle('state2');
                        });
                    }

                    if (muteBtn) {
                        muteBtn.addEventListener('click', () => {
                            player.getVolume().then(vol=> {
                                if (vol > 0) {
                                    player.setVolume(0);
                                } else if (vol <= 0){
                                    player.setVolume(1);
                                }
                            });
                            muteBtn.classList.toggle('state2');
                        });
                    }

                    if (fullBtn) {
                        fullBtn.addEventListener('click', () => {
                            player.requestFullscreen();
                        });
                    }
                break;
            }
        });
    }
}